export const getDefaultState = () => ({
  loading: false,
  header: {},
  footer: {},
  serviceData: {},
  serviceList: [],
  divisionList: [],
  customerTypeList: [],
  searchData: {
    loading: false,
    org_id: 0,
    customer_type_id: 0,
    service_category_id: 0
  },
  commonObj: {
    hasDropdownLoaded: false,
    therapyCenterList: [],
    assistiveDeviceList: [],
    ccList: [],
    hpcList: [],
    rxList: [],
    dhList: [],
    oeList: [],
    pmhList: [],
    adviceList: [],
    diagnosisList: [],
    disabilityTypeList: [],
    divisionList: [],
    districtList: [],
    upazilaList: [],
    unionList: [],
    cityCorporationList: [],
    pauroshobaList: [],
    wardList: [],
    orgList: [],
    officeTypeList: [],
    officeList: [],
    designationList: [],
    fiscalYearList: []
  },
  static: {
    loading: false
  },
  categoryList: [],
  orgList: [],
  faqList: [],
  newsList: [],
  noticeList: [],
  serviceUrl: {
    externalPanelServiceUrl: '',
    externalPanelCurrentServiceUrl: '',
    patientPanelCurrentServiceUrl: '',
    patientPanelCurrentServiceName: '',
    subsidyCircularId: 0
  }
})
